module.exports = __webpack_public_path__ + "img/legasy-of-dead.06f018c9.png";